"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _Domain = _interopRequireDefault(require("../records/Domain"));

var _DomainsActions = require("../actions/DomainsActions");

var _StagingActions = require("../actions/StagingActions");

var _handleActions;

var initialState = (0, _immutable.fromJS)({
  currentDomains: [],
  stagedAddDomains: [],
  stagedRemoveDomains: []
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _DomainsActions.FetchDomainsActionTypes.SUCCESS, function (state, action) {
  return state.set('currentDomains', (0, _immutable.List)(action.payload.data.map(function (domain) {
    return (0, _Domain.default)(domain);
  })).sort(function (a, b) {
    if (a.hosted && !b.hosted) {
      return -1;
    } else if (!a.hosted && b.hosted) {
      return 1;
    } else {
      if (a.domain < b.domain) {
        return -1;
      } else if (a.domain > b.domain) {
        return 1;
      }
    }

    return 0;
  }));
}), (0, _defineProperty2.default)(_handleActions, _DomainsActions.DomainsActionTypes.STAGE_ADD_DOMAIN, function (state, action) {
  if (state.get('stagedRemoveDomains').some(function (domain) {
    return domain.domain === action.payload;
  })) {
    return state.set('stagedRemoveDomains', state.get('stagedRemoveDomains').filter(function (domain) {
      return domain.domain !== action.payload;
    }));
  }

  return state.set('stagedAddDomains', state.get('stagedAddDomains').push((0, _Domain.default)({
    domain: action.payload,
    hosted: false
  })));
}), (0, _defineProperty2.default)(_handleActions, _DomainsActions.DomainsActionTypes.STAGE_REMOVE_DOMAIN, function (state, action) {
  if (state.get('stagedAddDomains').some(function (domain) {
    return domain.domain === action.payload;
  })) {
    return state.set('stagedAddDomains', state.get('stagedAddDomains').filter(function (domain) {
      return domain.domain !== action.payload;
    }));
  }

  return state.set('stagedRemoveDomains', state.get('stagedRemoveDomains').push(state.get('currentDomains').find(function (domain) {
    return domain.domain === action.payload;
  })));
}), (0, _defineProperty2.default)(_handleActions, _StagingActions.StagingActionTypes.CLEAR_STAGED_CHANGES, function (state) {
  return state.merge({
    stagedAddDomains: (0, _immutable.List)(),
    stagedRemoveDomains: (0, _immutable.List)()
  });
}), (0, _defineProperty2.default)(_handleActions, _DomainsActions.AddDomainActionTypes.SUCCESS, function (state, action) {
  return state.merge({
    stagedAddDomains: state.get('stagedAddDomains').filter(function (domain) {
      return domain.domain !== action.payload.props;
    }),
    currentDomains: state.get('currentDomains').push((0, _Domain.default)(action.payload.data))
  });
}), (0, _defineProperty2.default)(_handleActions, _DomainsActions.DeleteDomainActionTypes.SUCCESS, function (state, action) {
  return state.merge({
    stagedRemoveDomains: state.get('stagedRemoveDomains').filter(function (domain) {
      return domain.domain !== action.payload.props;
    }),
    currentDomains: state.get('currentDomains').filter(function (domain) {
      return domain.domain !== action.payload.props;
    })
  });
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;